import React from "react";
import {
  ButtonWrapper,
  GridElementFullWidth,
  OnboardingFormGrid,
  OnboardingFormWrapper,
  StepperItem,
  StepperItemInfo,
  StepperLine,
  StepperStepName,
  StepperWrapper,
} from "./style";
import {
  backText,
  nextText,
  POD_ONBOARDING_FLOW,
  submitText,
} from "utility/constants";
import { Button } from "@mui/material";
import {
  secondaryButtonStyles,
} from "utility/styles";
import { PodOnboardingStep1 } from "./components/PodOnboardingStep1";
import PodOnboardingStep2 from "./components/PodOnboardingStep2";
import { PodOnboardingStep3 } from "./components/PodOnboardingStep3";
import { usePodOnboarding } from "./ducks/hooks";
import { getIsSubmitingPodOnboardForm } from "./ducks/selectors";
import { useSelector } from "react-redux";
import {
  LoadingBtn,
  MidContainer,
  PageDescription,
  PageSubTitle,
  PageTitle,
  PageTopSection,
  PageWrapper,
} from "utility/styled-components";
import SettingIcon from "assets/SettingIcon";
import DocumentIcon from "assets/DocumentIcon";
import AddUserIcon from "assets/AddUserIcon";
import {
  WorkflowItem,
  WorkflowItemConnector,
  WorkflowItemDown,
  WorkflowItemIcon,
  WorkflowItemIconWrapper,
  WorkflowItemTop,
  WorkflowWrapper,
} from "shared-compoents/workflow-items/style";

interface PodOnboardingInterface {
  isSkipServerValidation?: boolean;
}

const STEPPER_ACTIVE_CLASS = "stepper-item-active";

function PodOnboarding({ isSkipServerValidation }: PodOnboardingInterface) {
  const {
    userFields,
    addUser,
    handleSubmit,
    addUserHandler,
    removeUserHandler,
    errors,
    architectureDiagramFile,
    onClickClearArchitectureFile,
    registerFunctions,
    step,
    onSubmit,
    MAX_STEP,
    handleGoBack,
    setStep3Error,
    clearStep3Errors,
    usersList,
    updateUserList,
    step3SetValue,
    addUserLater,
    isStep3Submitted,
    isValidatingStep1,
    validatingFieldsStep1,
    validatePodAbbreviation,
    podError,
    isValidatingPod,
    podAmbassadorEmailError,
    isValidatingPodAmbassadorEmail,
    validatePodAmbassadorEmail,
  } = usePodOnboarding({
    isSkipServerValidation
  });
  const isSubmitingPodOnboardForm = useSelector(getIsSubmitingPodOnboardForm);
  return (
    <PageWrapper>
      <MidContainer>
        <PageTopSection>
          <PageTitle>Pod Onboarding</PageTitle>
          <PageDescription>
            Pod Onboarding streamlines the setup of a new Data Science team in
            TDSP, ensuring seamless access, configurations, and prerequisite
            setups.
          </PageDescription>
        </PageTopSection>
        {/* <FeatureDetails>
          <FeatureDetailsTitle>
            Here is how Pod Onboarding will look like:
          </FeatureDetailsTitle>
          <FeatureDetailsList>
            <FeatureDetailsListItem>
              Platform Approval: The request is reviewed, and the basic
              requirements are checked and approved.
            </FeatureDetailsListItem>
            <FeatureDetailsListItem>
              Infrastructure & Access Setup: The team’s infrastructure is set
              up, and access roles/permissions are configured (Britive, Azure,
              and policies are applied).
            </FeatureDetailsListItem>
            <FeatureDetailsListItem>
              User & Platform Integration: The team members are added, and the
              necessary data and product platforms (Databricks and Sagemaker)
              are prepared for use.
            </FeatureDetailsListItem>
          </FeatureDetailsList>
        </FeatureDetails> */}
        <WorkflowWrapper>
          {
              POD_ONBOARDING_FLOW.map((flowItem, index) => (
                <>
                  <WorkflowItem key={ index + 1 }>
                    <WorkflowItemTop>{ flowItem.SLA ? "SLA: " + flowItem.SLA : ""  }</WorkflowItemTop>
                    <WorkflowItemIconWrapper><WorkflowItemIcon src={flowItem.image} /></WorkflowItemIconWrapper>
                    <WorkflowItemDown>{ flowItem.stageTitle }</WorkflowItemDown>
                  </WorkflowItem>
                  {
                    index < POD_ONBOARDING_FLOW.length - 1 && <WorkflowItemConnector />
                  }
                </>
              ))
            }
        </WorkflowWrapper>
        <form>
          <OnboardingFormWrapper>
            <PageSubTitle>Initiate Pod Onboarding Request</PageSubTitle>
            <OnboardingFormGrid>
              <GridElementFullWidth>
                <StepperWrapper>
                  <StepperItem>
                    <StepperLine className={ step >= 1 ? STEPPER_ACTIVE_CLASS : "" } />
                    <StepperItemInfo>
                      <SettingIcon width={19} height={19} fill={ step >= 1 ? "#052F46" : "#9E9E9E" } />
                      <StepperStepName className={ step >= 1 ? STEPPER_ACTIVE_CLASS : "" }>Basic Details</StepperStepName>
                    </StepperItemInfo>
                  </StepperItem>
                  <StepperItem>
                    <StepperLine className={ step >= 2 ? STEPPER_ACTIVE_CLASS : "" } />
                    <StepperItemInfo>
                      <DocumentIcon width={16} height={19} fill={ step >= 2 ? "#052F46" : "#9E9E9E" } />
                      <StepperStepName className={ step >= 2 ? STEPPER_ACTIVE_CLASS : "" }>Project Requirements</StepperStepName>
                    </StepperItemInfo>
                  </StepperItem>
                  <StepperItem>
                    <StepperLine className={ step >= 3 ? STEPPER_ACTIVE_CLASS : "" } />
                    <StepperItemInfo>
                      <AddUserIcon width={20} height={15} fill={ step >= 3 ? "#052F46" : "#9E9E9E" } />
                      <StepperStepName className={ step >= 3 ? STEPPER_ACTIVE_CLASS : "" }>Add Users</StepperStepName>
                    </StepperItemInfo>
                  </StepperItem>
                </StepperWrapper>
              </GridElementFullWidth>
              {step === 1 && (
                <PodOnboardingStep1
                  architectureDiagramFile={architectureDiagramFile}
                  onClickClearArchitectureFile={onClickClearArchitectureFile}
                  register={registerFunctions[1]}
                  errors={errors}
                  validatingFieldsStep1={validatingFieldsStep1}
                  validatePodAbbreviation={validatePodAbbreviation}
                  podError={podError}
                  isValidatingPod={isValidatingPod}
                  podAmbassadorEmailError={podAmbassadorEmailError}
                  isValidatingPodAmbassadorEmail={isValidatingPodAmbassadorEmail}
                  validatePodAmbassadorEmail={validatePodAmbassadorEmail}
                />
              )}
              {step === 2 && (
                <PodOnboardingStep2
                  register={registerFunctions[2]}
                  errors={errors}
                />
              )}
              {step === 3 && (
                <PodOnboardingStep3
                  register={registerFunctions[3]}
                  errors={errors}
                  removeUserHandler={removeUserHandler}
                  fields={userFields}
                  addUser={addUser}
                  setStep3Error={setStep3Error}
                  clearStep3Errors={clearStep3Errors}
                  addUserHandler={addUserHandler}
                  usersList={usersList}
                  updateUserList={updateUserList}
                  step3SetValue={step3SetValue}
                  addUserLater={addUserLater}
                  isSubmitted={isStep3Submitted}
                />
              )}
            </OnboardingFormGrid>
            <ButtonWrapper>
              <Button
                variant="contained"
                color="primary"
                onClick={handleGoBack}
                sx={secondaryButtonStyles}
                disabled={isSubmitingPodOnboardForm}
              >
                {backText}
              </Button>
              <LoadingBtn
                onClick={handleSubmit(onSubmit)}
                loadingIndicator={isValidatingStep1 ? "Validating" : "Submitting"}
                loading={isSubmitingPodOnboardForm || isValidatingStep1}
                loadingPosition="center"
                data-testid={`pod-onboarding-${(step === MAX_STEP ? submitText : nextText).toLowerCase()}-btn`}
              >
                {(isSubmitingPodOnboardForm || isValidatingStep1) ? "" : (step === MAX_STEP ? submitText : nextText)}
              </LoadingBtn>
            </ButtonWrapper>
          </OnboardingFormWrapper>
        </form>
      </MidContainer>
    </PageWrapper>
  );
}

export default PodOnboarding;
